import { styled } from '@mui/material/styles';
import { ReactComponent as BluViuLogo } from 'assets/blu-viu-logo.svg';
import React from 'react';

import { Box } from '@mui/material';

import LoadingSpinner from 'components/loading-spinner';

const OktaSignInWidget = React.lazy(() => import('./okta-sign-in-widget'));

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  paddingBottom: 20,
  background:
    'linear-gradient(to top, #012231, #012231, #012231, #012231, #012231, #012737, #002b3e, #003044, #003a53, #004563, #005073, #005b83)',
}));

const LoginLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  maxWidth: 1200,
  width: '100%',
}));

const LoginCard = styled(Box)(({ theme }) => ({
  alignItems: 'stretch',
  backgroundColor: theme.palette.darkBlue.main,
  borderRadius: 12,
  boxShadow: theme.shadows[4],
  display: 'flex',
  maxWidth: 1200,
  overflow: 'hidden',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    backgroundColor: 'transparent',
    border: 0,
    boxShadow: 'none',
    flexDirection: 'column',
    maxWidth: 570,
    overflow: 'visible',
  },
}));

const LogoPanel = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 0',
  justifyContent: 'center',
  maxWidth: 'none',
  minWidth: 0,
  padding: theme.spacing(8),
  width: '100%',
  '& svg': {
    display: 'block',
    height: 'auto',
    width: '100%',
  },
  [theme.breakpoints.down('md')]: {
    alignSelf: 'center',
    maxWidth: 420,
    padding: theme.spacing(6, 4),
  },
}));

const LoginPanel = styled(Box)(() => ({
  flex: '1 1 0',
  maxWidth: '100%',
  minWidth: 0,
  width: '100%',
}));

const Cookies = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontSize: 16,
  color: theme.palette.common.white,
  paddingBottom: theme.spacing(5),
}));

const Form = styled('div')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
}));

type LoginProps = {};

const Login: React.FC<LoginProps> = () => {
  return (
    <Wrapper>
      <LoginLayout>
        <LoginCard>
          <LogoPanel>
            <BluViuLogo width="100%" height="100%" />
          </LogoPanel>
          <LoginPanel>
            <Form>
              <React.Suspense fallback={<LoadingSpinner />}>
                <OktaSignInWidget />
              </React.Suspense>
              <Cookies>
                <span id="teconsent" style={{ marginRight: 5, textDecoration: 'underline' }}></span>
              </Cookies>
            </Form>
          </LoginPanel>
        </LoginCard>
      </LoginLayout>
    </Wrapper>
  );
};

export default Login;
